import { render, staticRenderFns } from "./OrganisationRoleSearchView.vue?vue&type=template&id=28762510&scoped=true&"
import script from "./OrganisationRoleSearchView.vue?vue&type=script&lang=js&"
export * from "./OrganisationRoleSearchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28762510",
  null
  
)

export default component.exports